export const addSpaces = (pascalCase: string) => {
  return pascalCase
    .split('')
    .map((char: string, index: number) => {
      return /[A-Z]/.test(char) && index > 0 ? ` ${char}` : char;
    })
    .join('');
};
